import { render, staticRenderFns } from "./ipt-area.vue?vue&type=template&id=b798bcc6&scoped=true&"
import script from "./ipt-area.vue?vue&type=script&lang=ts&"
export * from "./ipt-area.vue?vue&type=script&lang=ts&"
import style0 from "./ipt-area.vue?vue&type=style&index=0&id=b798bcc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b798bcc6",
  null
  
)

export default component.exports